module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-bg-ad7b2874e025a064c218ecddbd7c2a5c.svg";